@if (steps && steps.length) {
<!--  surface-section-->
  <div class="px-4 lg:py-5 py-4 md:px-6 lg:px-8">
<!--    flex-column md:-->
    <div class="flex flex-row lg:gap-5 gap-2">

      @for (step of steps; track step.id) {
<!--        border-left-3 border-top-none md:border-left-none md:-->
        <div
          (click)="handleStepChange(step)"
          [ngClass]="{'border-primary': activeStep == step.id, 'surface-border': activeStep != step.id, 'cursor-pointer': allowStepClick}"
          class="flex-auto border-top-3 pl-3 lg:py-3 py-0">
          <div
            [ngClass]="activeStep == step.id ? 'text-primary' : 'text-500'"
            class="text-500 font-bold mb-2 lg:block hidden">SCHRITT {{ step.id }}
          </div>
          <span class="text-color font-medium lg:block hidden">{{ step.label }}</span>
        </div>
      }
    </div>
  </div>
}

